import { apiCall, API_CONFIG } from './api';
import { IS_ALFAJR } from '../constants/general';

export const categoryAPI = {
  // Get all categories
  getCategories: async () => {
    return await apiCall(API_CONFIG.ENDPOINTS.CATEGORIES_LIST, {
      method: 'GET'
    });
  },

  // Add category or subcategory
  addCategory: async (payload, iconFile, imageFile) => {
    const formData = new FormData();

    formData.append('title', payload.title || '');
    formData.append('ar', payload.ar || '');
    formData.append('categoryId', payload.categoryId || '');
    formData.append('order', payload.order || '');
    formData.append('isHidden', payload.isHidden ?? false);

    if (payload._id) formData.append('_id', payload._id);
    if (payload.subCategoryId) formData.append('subCategoryId', payload.subCategoryId);
    if (payload.isGeneral) formData.append('isGeneral', payload.isGeneral);
    if (payload.generalSubCategoryId) formData.append('generalSubCategoryId', payload.generalSubCategoryId);

    if (!IS_ALFAJR) {
      formData.append('description', payload.description || '');
      formData.append('color', payload.color || '');
      if (iconFile instanceof File || iconFile instanceof Blob) {
        formData.append('icon', iconFile);
      }
    }

    if (imageFile instanceof File || imageFile instanceof Blob) {
      formData.append('image', imageFile);
    }

    return await apiCall(API_CONFIG.ENDPOINTS.CATEGORIES_ADD, {
      method: 'POST',
      body: formData
    });
  },

  // Update category or subcategory
  updateCategory: async (payload, iconFile, imageFile) => {
    const formData = new FormData();

    formData.append('_id', payload._id);

    if (payload.title) formData.append('title', payload.title);
    if (payload.ar !== undefined) formData.append('ar', payload.ar);
    if (payload.categoryId) formData.append('categoryId', payload.categoryId);
    if (payload.order !== undefined) formData.append('order', payload.order);
    if (payload.isHidden !== undefined) formData.append('isHidden', payload.isHidden);
    if (payload.subCategoryId) formData.append('subCategoryId', payload.subCategoryId);
    if (payload.isGeneral !== undefined) formData.append('isGeneral', payload.isGeneral);

    if (!IS_ALFAJR) {
      formData.append('description', payload.description || '');
      formData.append('color', payload.color || '');
      if (iconFile instanceof File || iconFile instanceof Blob) {
        formData.append('icon', iconFile);
      } else if (payload.clearIcon) {
        formData.append('clearIcon', 'true');
      }
    }

    if (imageFile instanceof File || imageFile instanceof Blob) {
      formData.append('image', imageFile);
    } else if (payload.clearImage) {
      formData.append('clearImage', 'true');
    }

    return await apiCall(API_CONFIG.ENDPOINTS.CATEGORIES_UPDATE, {
      method: 'POST',
      body: formData
    });
  },

  // Delete category
  deleteCategory: async (categoryId) => {
    const endpoint = API_CONFIG.ENDPOINTS.CATEGORIES_DELETE.replace(':id', categoryId);
    return await apiCall(endpoint, { method: 'DELETE' });
  },

  // Delete subcategory
  deleteSubcategory: async (categoryId, subCategoryId) => {
    const endpoint = API_CONFIG.ENDPOINTS.CATEGORIES_DELETE_SUBCATEGORY
      .replace(':categoryId', categoryId)
      .replace(':subCategoryId', subCategoryId);

    return await apiCall(endpoint, { method: 'DELETE' });
  },

  // Reorder category and subcategory
  reorderCategories: async (payload) => {
    return await apiCall(API_CONFIG.ENDPOINTS.CATEGORIES_REORDER, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  },

  // General Subcategory List
  getGeneralSubcategories: async () => {
    return await apiCall(API_CONFIG.ENDPOINTS.GENERAL_SUBCATEGORIES_LIST, {
      method: 'GET'
    });
  },

  // General Subcategory Add
  addGeneralSubcategory: async (payload) => {
    return await apiCall(API_CONFIG.ENDPOINTS.GENERAL_SUBCATEGORIES_ADD, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }
}
